import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "gfu-media__body gfu-search-form-item__body" }
const _hoisted_3 = ["data-qa"]
const _hoisted_4 = { class: "gfu-search-form-item__subtitle" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")

  return (_openBlock(), _createElementBlock("a", {
    href: $options.urlWithRef,
    class: "gfu-search-form-item gfu-media gfu-link gfu-link--nofx gfu-link--block"
  }, [
    _createVNode(_component_base_image, {
      src: $props.thumbImageUrl,
      alt: $props.title,
      width: "42",
      height: "42",
      class: "gfu-search-form-item__image",
      loading: "lazy"
    }, null, 8 /* PROPS */, ["src", "alt"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", {
        class: "gfu-search-form-item__title _line-clamp-1",
        "data-qa": `search-form-results-list-item:${$props.title}`
      }, _toDisplayString($props.title), 9 /* TEXT, PROPS */, _hoisted_3),
      _createElementVNode("span", _hoisted_4, [
        _renderSlot(_ctx.$slots, "subtitle")
      ])
    ])
  ], 8 /* PROPS */, _hoisted_1))
}